<template>
  <div>
    <l-tables :tableConfig="tableConfig"  :searchParams='searchData'  :noCreatText="$t('admin.equipment.noCreatText')" :ImgSrc='nullImg' @tableChange="handleTableHeaderChange">
      <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" :placeholder="$t('admin.equipment.searchPlaceholder')">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
        </a-input>
      </template>
      <template #statusName="{ record }">
        <span :style="{color:record.statusName==$t('admin.equipment.statusOpen')?'#2DB58B':'#F06321'}">{{record.statusName}}</span>
      </template>
      <template #trainingRoomName="{ record }">
        <span :style="[{color:record.trainingRoomName=='-'?'#FF6D00':''},{fontWeight:record.trainingRoomName=='-'?'600':''}]">
          {{record.trainingRoomName=='-' ? $t('admin.equipment.relinkRoom') : record.trainingRoomName}}
        </span>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="create">{{ $t('admin.equipment.createEquipment') }}</a-button>
      </template>
      <template slot="create">
        <a-button type="primary" @click="create">{{ $t('admin.equipment.createEquipment') }}</a-button>
      </template>
    </l-tables>
    <a-modal  width="259px" :closable='false' :visible="alertShow" @ok="alertShow = false" @cancel="alertShow = false">
      <div class='tit'>{{ $t('admin.equipment.unlinkedAlert.title', { count: num }) }}</div>
      <div class='content'>{{ $t('admin.equipment.unlinkedAlert.content') }}</div>
      <div slot="footer" class='footer'>
        <a-button type="primary" @click="alertShow = false">{{ $t('admin.equipment.unlinkedAlert.iKnow') }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import {
  getTrainingEquipmentList,
  getTrainingEquipmentNoRoomTotal,
  getTrainingEquipmentRoomList,
  getTrainingRoomList
} from '@/api/admin'


export default {
  components: {
    LTables
  },
  data() {
    return {
      noCreatText: this.$t('admin.equipment.noCreatText'),
      nullImg: require('@/assets/img/trainingEquipmengtListNull.png'),
      alertShow: false,
      num: 0,
      keyword: undefined,
      searchData: {
        name: ''
      },
      tableConfig: {
        tableName: this.$t('admin.equipment.title'),
        tableColumns: [
          {
            title: this.$t('admin.equipment.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80,
          },
          {
            title: this.$t('admin.equipment.name'),
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: this.$t('admin.equipment.number'),
            dataIndex: 'number',
            key: 'number',
            align: 'center'
          },
          {
            title: this.$t('admin.equipment.trainingRoom'),
            dataIndex: 'trainingRoomName',
            key: 'trainingRoomName',
            align: 'center',
            wdith: 300,
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [],
            scopedSlots: { customRender: 'trainingRoomName' },
          },
          {
            title: this.$t('admin.equipment.status'),
            dataIndex: 'statusName',
            key: 'statusName',
            align: 'center',
            width: 80,
            scopedSlots: { customRender: 'statusName' },
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.equipment.statusOpen'), value: '1' },
              { text: this.$t('admin.equipment.statusClose'), value: '2' }
            ],
          },
          {
            title: this.$t('admin.equipment.createdAt'),
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
          },
          {
            title: this.$t('admin.equipment.operations'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.equipment.deleteConfirm.title'),
          content: this.$t('admin.equipment.deleteConfirm.content')
        },
        tablePort: {
          list: '/training_equipment/list',
          del: '/training_equipment/delete'
        },
        tableEditRouteNName: 'equipmentListAdd'
      },
      trainingList:[]
    }
  },
  mounted() {
    this.getTrainingEquipmentRoomListHttp()
    this.getTrainingEquipmentNoRoomTotalHttp()
  },
  methods: {
    search(){
      this.searchData.name = this.keyword
    },
    getTrainingEquipmentRoomListHttp(){
      getTrainingEquipmentRoomList().then(res => {
        if (res.code == 200) {
          this.tableConfig.tableColumns[3].filters = res.data.list.map(item => {
            return {
              text: item.name,
              value: item.id
            }
          })
        }
      })
    },
    // 未关联实训室数量
    getTrainingEquipmentNoRoomTotalHttp(){
      getTrainingEquipmentNoRoomTotal().then(res => {
        if (res.code == 200) {
          if(res.data.total>0){
            this.alertShow = true
            this.num = res.data.total
          }
        }
      })
    },
    handleTableHeaderChange([filters,getList,sorter]) {
      let timeSort={}
      // 升序
      if(sorter.order === 'ascend'){
        timeSort.time_sort = 2
        // 倒序
      }else if(sorter.order === 'descend'){
        timeSort.time_sort = 1
      }
      const result = {...timeSort,...{trainingRoomIds:filters.trainingRoomName},...{statuses:filters.statusName}}

      console.log(result)
      getList({condition:result})
    },
    // 添加
    create() {
      this.$router.push({
        name: 'equipmentListAdd'
      })
    },

  }
}
</script>

<style lang="less" scoped>
.tit{
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
  margin:0 auto 12px auto;
  span{
    color: #FF6D00;
  }

}
.content{
  font-weight: 400;
  font-size: 14px;
  color: #596777;
  text-align: center;
  margin: 0 auto;
}
.footer{
  button{
    margin: 0 auto !important;
  }
}
/deep/.ant-table-thead > tr > th .anticon-filter, .ant-table-thead > tr > th .ant-table-filter-icon{
  right: auto !important;
}
/deep/ .ant-table-filter-dropdown .ant-dropdown-menu{
  max-height: 319px !important;
  overflow-x: auto !important;
}
</style>
